import styled from 'styled-components';

export const WarningWrapper = styled.div`
  display: flex;
  align-items: center;
  background: darkorange;
  border-radius: 2px;
  color: #fff;
  padding: 8px 5px;
  margin-bottom: 1.5rem;
  i {
    font-size: 1.6rem;
    margin: 0 .5rem;
  }
`;
